<template>
  <nav class="topbar">
    <!-- Brand -->
    <nuxt-link to="/" class="topbar-brand">
      <!-- <div class="brand-mark">S</div> -->
      <div class="brand-info">
        <span class="brand-name">Crossfit Event Scanner</span>
        <span class="brand-sub">CrossFit · France · 2026</span>
      </div>
    </nuxt-link>

    <!-- Navigation links (desktop) -->
    <div class="topbar-nav">
      <nuxt-link to="/" class="topbar-nav-link">Événements</nuxt-link>
      <nuxt-link to="/calendar" class="topbar-nav-link">Calendrier</nuxt-link>
      <nuxt-link to="/map" class="topbar-nav-link">Carte</nuxt-link>
    </div>

    <!-- Right actions (desktop) -->
    <div class="topbar-right">
      <nuxt-link
        v-if="user"
        to="/admin"
        class="topbar-right-item topbar-admin-desktop"
        >Admin</nuxt-link
      >
      <button v-if="user" class="topbar-right-item" @click="signOut()">
        Logout
      </button>
      <nuxt-link v-if="!user" to="/login" class="topbar-right-item">
        Login
      </nuxt-link>
      <div class="topbar-sep" />
      <nuxt-link
        to="/suggest-event"
        class="topbar-right-item pill-cta topbar-cta topbar-suggest-desktop"
      >
        + Suggérer
      </nuxt-link>
    </div>
  </nav>
</template>

<script setup lang="ts">
const { auth } = useSupabaseClient();
const user = useSupabaseUser();
const router = useRouter();

async function signOut() {
  await auth.signOut();
  router.push('/');
}
</script>
